var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"is-flex is-flex-direction-column"},[_c('h1',{staticClass:"title pt-6 pb-4"},[_vm._v(" Vielen Dank für dein Interesse und viel Freude mit unserem Newsletter! ")])])
}]

export { render, staticRenderFns }